import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import MatchesDashboard from "./pages/MatchesDashboard";
import TeamsPage from "./pages/TeamsPage";
import TournamentsPage from "./pages/TournamentsPage";
import CricketController from "./pages/CricketController";
import OverlayPage from "./pages/OverlayPage";
import ManualPage from "./pages/ManualPage";

function Protected({ children, adminOnly }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/matches" replace />;
  return children;
}

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  // Anonymous visitors see the public landing page
  if (!user) return <LandingPage />;
  // Logged-in users go straight to their dashboard
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/matches" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
          <Route path="/matches" element={<Protected><MatchesDashboard /></Protected>} />
          <Route path="/teams" element={<Protected><TeamsPage /></Protected>} />
          <Route path="/tournaments" element={<Protected><TournamentsPage /></Protected>} />
          <Route path="/controller/:matchId" element={<Protected><CricketController /></Protected>} />
          <Route path="/manual" element={<Protected><ManualPage /></Protected>} />
          {/* Public overlay routes for vMix / OBS */}
          <Route path="/overlay/:matchId" element={<OverlayPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
